import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var SelectorApi = /** @class */ (function () {
    function SelectorApi(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    SelectorApi.initialize = function (basePath, fetchApi) {
        if (!SelectorApi.instance) {
            SelectorApi.instance = new SelectorApi(basePath, fetchApi);
        }
        return SelectorApi.instance;
    };
    SelectorApi.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'user'
        });
        return new NocoHttpClient.ApiUserV1SelectorApi(new Configuration(config));
    };
    return SelectorApi;
}());
export { SelectorApi };
